<form [formGroup]="form">
    <p class="help-text">Choose a company to file this new account information.</p>
    <mat-form-field appearance="outline" *ngIf="entities$ | async as entities">
        <mat-label>Company</mat-label>
        <select matNativeControl id="entity" formControlName="entityId" required [errorStateMatcher]="errorMatcher">
            <option *ngIf="!entities.length" value="" selected>Select a Company</option>
            <option *ngFor="let entity of entities" [value]="entity.id">
                {{ entity.name }}
            </option>
        </select>
    </mat-form-field>
</form>
